import * as React from 'react';
import 'bootstrap/dist/css/bootstrap.css'
import '../theme/scss/app.scss';
import Loader from '../components/common/loader';

import Router from './router';

export default class MiranaApp extends React.Component {

    public render() {
        return (
            <div>
                <Loader/>
                <div>
                    <Router/>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/app.tsx